import { useState, useEffect, useContext } from 'react';
import { Button, IconButton, TextField } from '@mui/material';
import Table from '../custom/Table';
import { SERIAL_NUMBER_REGEX, TRANSACTION_STATUS, TRANSACTION_TYPES } from '../../utils/constant';
import { useNavigate, useParams } from 'react-router-dom';
import { TransactionContext } from '../../contexts/TransactionContext';
import { TColumn, TStepsProps } from '../../Models/common';
import { NotificationContext } from '../../contexts/NotificationContext';
import useService from '../../hooks/useService';
import { confirmPhysicalOrder, getPhysicalOrder, getProducts as getProductsService } from '../../services/Transactions';
import { TConfirmProductColumns } from '../../Models/PhysicalOrder';
import StepNavigation from '../custom/StepNavigation';
import Title from '../custom/Title';
import styled from 'styled-components';
import SerialNumberSelectorModal from '../$PhysicalOrder/SerialNumberSelector';
import VisibilityIcon from '@mui/icons-material/Visibility'

const Divider = styled.div`
    border: 1px solid #EBEBEC;
`


const ConfirmPhysicalOrder = (props: TStepsProps) => {
    const { path, nextButtonLable, nextSection, prevSection } = props
    const navigate = useNavigate()
    const { execute } = useService();
    // Physical Order orderCategory BUY
    const { capturedSteps, transactionInfo, physicalOrder } = useContext(TransactionContext)
    const { notify } = useContext(NotificationContext)
    const { id } = useParams()

    const redirectToIncompleteStep = () => {
        if (prevSection && !capturedSteps.includes(prevSection)) {
            goToPrevSection()
        }
    }

    const goToNextSection = () => {
        if (!capturedSteps.includes('PHYSICAL_ORDER'))
            return notify('Complete Physical Order first.', 'error')

        if (id) navigate(path + '/' + id + '?section=' + nextSection)
        else navigate(path + '?section=' + nextSection)
    }

    const goToPrevSection = () => {
        if (id) navigate(path + '/' + id + '?section=' + prevSection)
        else navigate(path + '?section=' + prevSection)
    }


    useEffect(() => {
        redirectToIncompleteStep()
        console.log('physicalOrder', physicalOrder)
        if (physicalOrder?.id && transactionInfo.status === TRANSACTION_STATUS.CONFIRM_PHYSICAL_ORDER) {
            execute(() => getPhysicalOrder({
                globalTransactionNumber: transactionInfo.globalTransactionNumber!,
                transactionType: transactionInfo.transactionType
            }))
        }
    }, [])



    return (
        <div style={{ padding: '0 10px' }}>
            <Products id={id!} nextSection={nextSection!} path={path!} />
            <StepNavigation
                capturedSteps={capturedSteps}
                currentSection='CONFIRM_PHYSICAL_ORDER'
                goToNextSection={goToNextSection}
                nextButtonLable={nextButtonLable}
                goToPrevSection={goToPrevSection}
                prevSection={prevSection}
            />
        </div>
    )
}

const Products = ({id,nextSection,path}:{id:string,nextSection:string,path:string}) => {
    const { physicalOrder, setCart ,  transactionInfo : { status,  transactionType, globalTransactionNumber },setCapturedSteps,isInventoryExist } = useContext(TransactionContext)
    const { lineItems } = physicalOrder
    const { notify } = useContext(NotificationContext)
    const [serialNumbers, setSerialNumbers] = useState<{ [key: string]: string }>({})
    const { execute } = useService();
    const navigate = useNavigate();
    const [showSerialNumberModal, setShowSerialNumberModal] = useState<boolean | string>(false);
    const [availableSerialNumbers, setAvailableSerialNumbers] = useState<{ [key: string]: number[] }>({})
    const [selectedSerialNumbers, setSelectedSerialNumbers] = useState<{ [key: string]: number[] }>({})
    const [quantity, setQuantity] = useState<{ [key: string]: string }>({})
    const [serialNumberItemIds, setSerialNumberItemIds] = useState<{ [key: string]: string}>({});
    
    const productColumns: TColumn<TConfirmProductColumns>[] = [
        {
            field: 'skuId',
            headerName: 'Item Number',
            minWidth: 250
        },
        {
            field: 'productName',
            headerName: 'Item Name',
            minWidth: 350
        },
        {
            field: 'description',
            headerName: 'Item Description',
            minWidth: 400,
        },
        {
            field: 'quantity',
            headerName: 'Quantity',
            minWidth:100
        },
        {
            field: 'isSerialNumbers',
            headerName: 'Serial Numbers',
            minWidth: 240,
            renderCell(params) {
                return params.row.isSerialNumbers ? 
                    <>
                        {    
                            <IconButton onClick={() => openSerialModal(params.row.skuId)}>
                                <VisibilityIcon />
                            </IconButton>
                        }
                    </>  : <></>
                // return params.row.isSerialNumbers ? <TextField
                //     required
                //     value={serialNumbers[params.id]}
                //     onChange={e => changeSerialNumbers(e, params.id as string)}
                //     size='small'
                //     onKeyDown={e => e.stopPropagation()}
                // /> : <></>
            },
        }
    ]

    const openSerialModal = (id: string) => {
        setShowSerialNumberModal(id);
    }

    useEffect(()=>{
        if(transactionType === TRANSACTION_TYPES.JOB_WORK && !isInventoryExist && status === TRANSACTION_STATUS.CONFIRM_PHYSICAL_ORDER){
            notify('Inventory Acknowledgement Pending..')
        }
    },[isInventoryExist])

    useEffect(()=>{
        if( lineItems?.length ){
            lineItems?.map(lineItem => {
                if( lineItem.product?.is_serial_no && lineItem?.serialNumbers){
                    const parsedSerialNumbers = JSON.parse(lineItem.serialNumbers);
                    setAvailableSerialNumbers((prev) => ({ ...prev, [lineItem.productId]: parsedSerialNumbers }))
                    setQuantity(prev => ( {...prev, [lineItem.productId] : String(lineItem.quantity) }))
                } 
            })
        }
    },[lineItems])

    const getProductRows = ()  => {
        return lineItems?.map(lineItems => (
            {
                skuId : lineItems.productId,
                productName: lineItems.product?.product_name,
                description : lineItems.product?.description,
                isSerialNumbers : lineItems.product?.is_serial_no,
                quantity: lineItems.quantity
            } 
        ))
    }


    const changeSerialNumbers = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, id: string) => {
        const value = e.target.value
        console.log('serial numbers', SERIAL_NUMBER_REGEX.test(value), value)
        if (!value.length) return setSerialNumbers(prev => ({ ...prev, [id]: '' }))
        else if (SERIAL_NUMBER_REGEX.test(value)) setSerialNumbers(prev => ({ ...prev, [id]: value }))
        else setSerialNumbers(prev => ({ ...prev, [id]: prev[id] }))
    }

    const submitHandler = async () => {
        for( let lineItem of lineItems! ){
            if ( lineItem.product?.is_serial_no ) {
                const serialNumbersOfSku = selectedSerialNumbers[lineItem.productId] ;
                console.log("lineItem",lineItem)
                console.log("serialNumbersOfSku",serialNumbersOfSku,selectedSerialNumbers[lineItem.productId])
                if( !serialNumbersOfSku ){
                    return notify(`Please select serial number for item ${lineItem.product.product_name}`,'error')
                }else if (lineItem.product?.is_serial_no && serialNumbersOfSku.length > lineItem.quantity) {
                    return notify(`Serial Numbers can't be more than quantity for item ${lineItem.product.product_name}`, 'error')
                } else if (lineItem.product?.is_serial_no && serialNumbersOfSku.length < lineItem.quantity) {
                    return notify(`Serial Numbers can't be less than quantity for item ${lineItem.product.product_name}`, 'error')
                }
            }
            // if( lineItem.product?.is_serial_no && serialNumbers[lineItem.productId] ){
            //     const commaSaperatedSerialNumbers : any = []
            //     const serialNumbersOfSku = serialNumbers[lineItem.productId]
            //     const commaSaperatedSerialNumbersArray = serialNumbersOfSku.split(',')
            //     commaSaperatedSerialNumbersArray.forEach(serialNumber => {
            //         const srNumbersArray = serialNumber.split('-')
            //         if (srNumbersArray.length > 1) {
            //             for (let i = Number(srNumbersArray[0]); i <= Number(srNumbersArray[srNumbersArray.length - 1]); i++) {
            //                 commaSaperatedSerialNumbers.push(i)
            //             }
            //         } else commaSaperatedSerialNumbers.push(Number(srNumbersArray[0]))
            //     })
            //     if ( lineItem.product?.is_serial_no && commaSaperatedSerialNumbers.length != lineItem.quantity)
            //     return notify(`All serial numbers must be entered for item ${lineItem.product.product_name}`,'error')
            // }else if( lineItem.product?.is_serial_no && !serialNumbers[lineItem.productId] ){
            //     return notify(`All serial numbers must be entered for item ${lineItem.product.product_name}`,'error')
            // }
        }

        if( globalTransactionNumber ){
            let lineItemsData: { [key: string]: any } = {}; 
            lineItems?.map(lineItem =>{
                const id : string = lineItem.productId;
                const value = selectedSerialNumbers[id] || "";
                lineItemsData[id] = value;
            });
            console.log("linteItemsData",lineItemsData);
            const { data, error } = await execute(()=> confirmPhysicalOrder({
                globalTransactionNumber,
                transactionType,
                data: lineItemsData
            }))
            if( data !== null && data.confirmOrder ){
                notify('Physical Order Confirmed');
                setCapturedSteps(prev=> [...prev, 'CONFIRM_PHYSICAL_ORDER'])
                navigate(path + '/' + id + '?section=' + nextSection)
            }
            console.log(data,"data");
        }
    }



    useEffect(() => {
        getProductRows()
    }, [])

    return (
        <div style={{ padding: '20px 0' }}>
            <SerialNumberSelectorModal
                availableSerialNumbers={availableSerialNumbers[showSerialNumberModal as string]}
                onClose={(updatedSerialNumbers) => {
                    setSelectedSerialNumbers(prev => ({ ...prev, [showSerialNumberModal as string]: updatedSerialNumbers }))
                    setCart(prev => {
                        return [...prev.map(item => {
                            if (item.productId === showSerialNumberModal) {
                                return { ...item, serialNumbers: updatedSerialNumbers.join(',') }
                            } else return item
                        })]
                    })
                    setShowSerialNumberModal(false)
                }}
                quantity={+quantity[showSerialNumberModal as string]}
                selectedSerialNumbers={selectedSerialNumbers[showSerialNumberModal as string]}
                show={Boolean(showSerialNumberModal)}
                isStepCompleted={ status !== TRANSACTION_STATUS.CONFIRM_PHYSICAL_ORDER }
            />
            <Title>Confirm Physical Order Details</Title>
            <Divider style={{ marginBottom: '10px' }} />
            {!isInventoryExist && status === TRANSACTION_STATUS.CONFIRM_PHYSICAL_ORDER ? <Title>Product Acknowledgement Pending from Plant, please continue later...</Title>
            :
            <Table columns={productColumns} rows={getProductRows() || []} getRowId={(row: TConfirmProductColumns) => row.skuId} />
            }
            { status === TRANSACTION_STATUS.CONFIRM_PHYSICAL_ORDER && 
                <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginTop:'10px'}}>
                    <Button disabled={!isInventoryExist} variant='contained' onClick={submitHandler} >Confirm Order</Button>
                </div>
            }
        </div>
    )
}

export default ConfirmPhysicalOrder
